import React from 'react';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import get from 'lodash/get';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout/layout';
import Service from '../components/service/service';

import './index.scss';

class RootIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title');

    const pageInfo = get(this, 'props.data.pageInfo');
    const services = get(this, 'props.data.services.edges');
    const heroImage = pageInfo.heroImage.fluid;
    const logo = get(this, 'props.data.logo.childImageSharp.fluid');

    return (
      <Layout location={this.props.location}>
        <Helmet title={siteTitle}>
          <meta name="description" content="Spazio 536 - Centro estetico" />
        </Helmet>

        <div
          className="full-width-img"
          style={{
            backgroundImage: `url(${heroImage.src})`,
            backgroundPosition: `center`,
            backgroundRepeat: `no-repeat`,
            backgroundSize: `cover`,
          }}
        >
          <Img fluid={logo} style={{ position: `relative`, left: `15%`, top: `25%`, maxWidth: `25%` }} />
        </div>

        <div className="page-title-wrapper">
          <h4 className="subtitle">{pageInfo.subtitle}</h4>
        </div>

        <h4 className="page__title">Cura & bellezza</h4>
        <hr />
        <span className="page__subtitle">I nostri servizi e trattamenti</span>

        <div className="services">
          {services.map(service => (
            <Service service={service.node} />
          ))}
        </div>

        <h4 className="page__title" id="dove-siamo">
          Dove siamo
        </h4>
        <hr />
        <span className="page__subtitle">Vienici a trovare</span>

        <iframe
          loading="lazy"
          allowFullScreen
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCy9MU_gk-uh2y6r0BLVuWK_auGoorrB2w&q=Spazio+536+-studio+estetico-"
        ></iframe>
      </Layout>
    );
  }
}

export default RootIndex;

export const pageQuery = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
      }
    }

    logo: file(relativePath: { eq: "logo-white.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    pageInfo: contentfulPaginaWeb(webPageTitle: { eq: "Home" }) {
      subtitle
      heroImage {
        fluid {
          ...GatsbyContentfulFluid_tracedSVG
        }
      }
    }

    services: allContentfulService {
      edges {
        node {
          name
          slug
          image {
            fluid {
              ...GatsbyContentfulFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`;
